import { FilterModel, SortModel } from '@tassat/common-definitions';
import { FirmRecord } from '@tassat/fred-definitions';
import { createContext } from 'react';

export interface IGridModelContext {
    filterModel?: FilterModel;
    onFilter?: (selected, current?) => void;
    sortModel?: SortModel;
    onSort?: (selected, current?) => void;
    onSearch?: (searchValue) => void;
    searchValue?: string;
    onExport?: () => void;
    onFilterChange: (records: FirmRecord[]) => unknown;
}

const GridModelContext = createContext<IGridModelContext | null>(null);

export { GridModelContext };